module.exports = __webpack_public_path__ + "img/mac.9ccbd8eb.svg";